import { FETCH_HEADER_DATA } from './constants'

export const fetchHeader = {
  request: (language, version) => ({ type: FETCH_HEADER_DATA['REQUEST'], language, version }),
  success: header => ({
    type: FETCH_HEADER_DATA['SUCCESS'],
    header
  }),
  failure: error => ({type: FETCH_HEADER_DATA['FAILURE'], error})
}



// WEBPACK FOOTER //
// ./src/containers/Header/actions.js